/**
 * Search and filters for the admin account list (QA finding ADMIN-04).
 *
 * Search and filters each used to rebuild the list from the full set of
 * accounts, so applying one silently discarded the other. Search also compared
 * the whole query to the first or last name alone, so a full name such as
 * "Test Editor" matched nobody. The screen now applies both together, through
 * these two functions.
 */

const words = (value) =>
  String(value || "")
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .filter(Boolean);

/**
 * Every word typed must begin one of the person's names - first, middle or
 * last - so "test", "edi", "test editor" and "editor test" all find
 * "Test Editor". An empty search matches everyone.
 */
export function matchesAccountSearch(user, term) {
  const query = words(term);
  if (query.length === 0) return true;
  const names = [user?.firstName, user?.middleName, user?.lastName].flatMap(words);
  return query.every((q) => names.some((name) => name.startsWith(q)));
}

/**
 * Filters arrive as [{ parentOption, subOption }]. Choices under one heading
 * are alternatives; headings must all match.
 */
export function matchesAccountFilters(user, filters) {
  const chosen = (heading) =>
    (filters || []).filter((f) => f.parentOption === heading).map((f) => f.subOption);

  const roles = chosen("Role");
  if (roles.length && !roles.includes(user?.rollSelect)) return false;

  const subRoles = chosen("Sub Role");
  const userSubRoles = Array.isArray(user?.subRole) ? user.subRole : [];
  if (subRoles.length && !subRoles.some((s) => userSubRoles.includes(s))) return false;

  const states = chosen("Account State");
  if (states.length) {
    const banned = user?.banAccount === true;
    const ok = states.some((s) => (s === "Ban" && banned) || (s === "Unban" && !banned));
    if (!ok) return false;
  }
  return true;
}
